import { NgModule } from '@angular/core';
import {MdInputModule,MdSelectModule} from '@angular/material';

@NgModule({
  declarations: [

  ],
  imports: [
  MdInputModule,MdSelectModule
  ],
  exports:[MdInputModule,MdSelectModule],
  providers: [],

})
export class MaterialModule { }



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/shared/material-design/material-module.ts